import icon from 'vue-svgicon';

icon.register({
    'regular/lab-flask-experiment': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.726.75h10.5M15.726 8.25V.75h-7.5v7.5L1.489 18.615A3 3 0 0 0 4 23.25h15.948a3 3 0 0 0 2.515-4.635zM5.301 12.75h13.35M14.226 17.25h3M15.726 15.75v3M6.726 19.125a.375.375 0 0 1 .374.375M6.351 19.5a.375.375 0 0 1 .375-.375M6.726 19.875a.375.375 0 0 1-.375-.375M7.1 19.5a.375.375 0 0 1-.375.375M9.726 16.125a.375.375 0 0 1 .375.375M9.351 16.5a.375.375 0 0 1 .375-.375M9.726 16.875a.375.375 0 0 1-.375-.375M10.1 16.5a.375.375 0 0 1-.375.375M15.726 3.75h-3M15.726 6.75h-3"/>`,
    },
});
